import React from 'react'
import Spinner from './Spinner'
function DownloadedContent(props) {

    const { thumbnail, title, format, download, duration, progress } = props

    return (
        <>

            <section className="text-gray-600 body-font">
                <div className="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">

                    <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 mb-10 md:mb-0">
                        <img className="object-cover object-center rounded mx-auto" alt="hero" src={thumbnail} width={300} />
                    </div>
                    <div className="lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 flex flex-col md:items-start md:text-left items-center text-center">
                        <h1 className="title-font sm:text-4xl text-2xl mb-4 font-medium text-white">{title}
                        </h1>
                        <p className="mb-8 leading-relaxed text-[#1A56DB] font-semibold">Duration : {duration}</p>
                        <div className="flex justify-center">
                            {
                                progress !== 100 ? <><Spinner /> <p className='leading-relaxed text-black font-semibold align-middle'>{progress} %</p></> :
                                    <a className="inline-flex text-white font-semibold bg-[#1A56DB] border-0 py-2 px-6 focus:outline-none hover:bg-white hover:text-[#111827] as rounded sm:text-lg" href={download} target={format === 'mp3' ? "" : "_blank"} rel="noreferrer">Download {format === 'mp3' ? "Audio" : "Video"}</a>
                            }

                            <a className="ml-4 inline-flex text-[#111827] font-semibold bg-gray-100 border-0 py-2 px-6 focus:outline-none hover:bg-[#1A56DB] hover:text-white rounded sm:text-lg" href="#form">Convert Next</a>

                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default DownloadedContent